export default __webpack_public_path__ + "static/media/lynnLeft.ecfd6499.png";